import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comite-investimentos',
  templateUrl: './comite-investimentos.component.html',
  styleUrls: ['./comite-investimentos.component.css']
})
export class ComiteInvestimentosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
